import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { containsFernwaerme, getMonthLabel } from '@mwe/utils';
import { Sparte, Teilbetrag } from '@mwe/models';
import dayjs from 'dayjs';
import { ProfileService } from '@mwe/services';
import { FeatureToggleEnum } from '@mwe/constants';

@Pipe({ name: 'partialPaymentLabel' })
export class PartialPaymentLabelPipe implements PipeTransform {
  private readonly translateService = inject(TranslateService);
  private readonly profileService = inject(ProfileService);

  get isFeatureToggleEnabled() {
    return this.profileService.isFeatureToggleEnabled(FeatureToggleEnum.HEAT_BILLING_CYCLE_NEW);
  }

  transform(
    label: string,
    date: string,
    categories: Sparte[],
    partialAmountCalculation: Pick<Teilbetrag, 'zeitraumVon' | 'zeitraumBis' | 'abschlagzyklus'>,
  ): string {
    return containsFernwaerme(categories)
      ? this.getWaermeDescription(label, date, partialAmountCalculation)
      : this.getDescription(label, date);
  }

  private getDescription(label: string, date: string): string {
    const month = this.translateService.instant(getMonthLabel(date));

    return this.translateService.instant(label, { month });
  }

  private getWaermeDescription(
    label: string,
    date: string,
    partialAmountCalculation: Pick<Teilbetrag, 'zeitraumVon' | 'zeitraumBis' | 'abschlagzyklus'>,
  ): string {
    let month: string;

    if (this.isFeatureToggleEnabled) {
      if (!(partialAmountCalculation?.zeitraumVon && partialAmountCalculation?.zeitraumBis && partialAmountCalculation?.abschlagzyklus)) {
        month = '';
      }

      if (partialAmountCalculation?.abschlagzyklus === '01') {
        month = this.translateService.instant(getMonthLabel(dayjs(partialAmountCalculation?.zeitraumBis)));
      }

      if (partialAmountCalculation?.abschlagzyklus === '02') {
        const currentMonth = this.translateService.instant(getMonthLabel(dayjs(partialAmountCalculation?.zeitraumBis)));
        const previousMonth = this.translateService.instant(
          getMonthLabel(dayjs(partialAmountCalculation?.zeitraumBis).subtract(1, 'month')),
        );
        month = `${previousMonth}&nbsp;/ ${currentMonth}`;
      }
    }

    if (!this.isFeatureToggleEnabled) {
      const currentMonth = this.translateService.instant(getMonthLabel(date));
      const previousMonth = this.translateService.instant(getMonthLabel(dayjs(date).subtract(1, 'month')));
      month = `${previousMonth}&nbsp;/ ${currentMonth}`;
    }

    return this.translateService.instant(label, { month });
  }
}
